import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import MarqueeStrip from './components/MarqueeStrip';
import AboutSection from './components/AboutSection';
import EmbroiderySection from './components/EmbroiderySection';
import GalleryPreview from './components/GalleryPreview';
import CTASection from './components/CTASection';
import SEO, { SITE_URL } from '../../components/feature/SEO';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '하이반텍스 HivanTex',
    url: SITE_URL,
    description: '하이반텍스(HivanTex)는 프리미엄 불리온 엠블럼과 핸드메이드 자수 전문 브랜드입니다.',
    inLanguage: 'ko',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '하이반텍스 HivanTex',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    foundingDate: '1991',
    description: '1991년 설립된 프리미엄 불리온 엠블럼 및 핸드메이드 자수 전문 기업',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '답십리로68길 31, 3층',
      addressLocality: '동대문구',
      addressRegion: '서울특별시',
      addressCountry: 'KR',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+82-10-8958-0286',
      contactType: 'customer service',
      email: 'info@hivantex.com',
      availableLanguage: ['Korean'],
    },
    sameAs: [],
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <SEO jsonLd={homeJsonLd} />
      <Navbar />
      <Hero />
      <MarqueeStrip />
      <AboutSection />
      <EmbroiderySection />
      <GalleryPreview />
      <CTASection />
      <Footer />
    </div>
  );
}
